"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.featureFunctions = exports.browserChecking = exports.BrowserFeatures = void 0;
var BrowserFeatures;
(function (BrowserFeatures) {
  BrowserFeatures[BrowserFeatures["COOKIES"] = 0] = "COOKIES";
  BrowserFeatures[BrowserFeatures["LOCALSTORAGE"] = 1] = "LOCALSTORAGE";
  BrowserFeatures[BrowserFeatures["SESSIONSTORAGE"] = 2] = "SESSIONSTORAGE";
})(BrowserFeatures || (exports.BrowserFeatures = BrowserFeatures = {}));
const featureFunctions = exports.featureFunctions = [{
  name: BrowserFeatures.COOKIES,
  isFeatureEnabled: () => {
    return navigator.cookieEnabled;
  },
  errorMessageKey: 'pleaseEnableCookies',
  errorMessage: 'Please Enable Cookies'
}, {
  name: BrowserFeatures.LOCALSTORAGE,
  isFeatureEnabled: () => {
    try {
      return window.localStorage !== null && window.localStorage !== undefined;
    } catch (error) {
      return false;
    }
  },
  errorMessageKey: 'pleaseEnableLocalStorage',
  errorMessage: 'Please Enable Local Storage'
}, {
  name: BrowserFeatures.SESSIONSTORAGE,
  isFeatureEnabled: () => {
    try {
      return window.sessionStorage !== null && window.sessionStorage !== undefined;
    } catch (error) {
      return false;
    }
  },
  errorMessageKey: 'pleaseEnableSessionStorage',
  errorMessage: 'Please Enable Session Storage'
}];
const browserChecking = requiredFeatures => {
  const missingFeatures = requiredFeatures.filter(featureName => {
    return !featureFunctions.find(feature => feature.name === featureName)?.isFeatureEnabled();
  });
  return missingFeatures;
};
exports.browserChecking = browserChecking;